/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2023. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
const ID = {
  FAQ_FOOTER_ID: 'footer-faq',
  CONTACT_US_FOOTER_ID: 'footer-contactUs',
  SECURITY_FOOTER_ID: 'footer-security',
  PRIVACY_FOOTER_ID: 'footer-privacy',
  ACCESSIBILITY_FOOTER_ID: 'footer-accessibility',
  DISCLAIMER_FOOTER_ID: 'footer-disclaimer',
};

/* eslint-disable import/prefer-default-export */
export { ID };
